import styled from 'styled-components'

export const Container = styled.div`
  position: absolute;
  width: 100%;
  height: 100vh;
`

export const VRContent = styled.div`
  width: 100%;
  height: calc(100vh - 40px);
  background: #FFF;
`